export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/icon-main-kw-logo-light-4c314b8490a72fc1dd6a95303c13aa40.svg";